import React, { useState, useRef } from 'react'
import Header from '../../components/Header'
import { InputText } from "primereact/inputtext";
import { Link } from "react-router-dom";
import { Checkbox } from 'primereact/checkbox';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import Logo from '../../assets/images/logo.png';
import { Divider } from 'primereact/divider';
import { Image } from 'primereact/image';
import sidebar from "../../assets/images/sidebarright.svg"
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import {
  Schools, Subject,
  SixthPeriodAssignmentInitiateReport,
  SixthPeriodReportTransactionCycle,

} from "../../models";

import moment from "moment";
import { reactLocalStorage } from 'reactjs-localstorage';
import HtmlToPdfSix from '../../components/popup/sixPeriodPDF/htmltopdf';
import {InputSwitch} from "primereact/inputswitch";
import {Card} from "primereact/card";

const SixperiodAgreement = (props) => {

  const [checked, setChecked] = useState(false);
console.log(props.specificReportDetailsEdit)
console.log('signatureFileAwsPath: ', props.signatureFileAwsPath);
const [buttonClicked, setButtonClicked] = useState(false);

  const handleAcknowledgeClick = () => {
    props.onAcknowledge();
	//props.onClosePopup();
  }
  
  const handleRejectClick = () => {
        // Perform your desired action here

        // Set the state to indicate that the button has been clicked
        setButtonClicked(true);
		props.onRejectPopup();
		//props.onClosePopup();
    };
	


  // const approveAcknowledgeSelectedConfirm = async (reportId) => {
  //   const loggedUserId = reactLocalStorage.get("loggedUserId");

  //   const sixthPeriodAssignmentInitiateReport = await DataStore.query(SixthPeriodAssignmentInitiateReport, (c) => c.id.eq(reportId));

  //   const newNextOriginal1 = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId), {
  //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
  //   });

  //   await DataStore.save(
  //     SixthPeriodReportTransactionCycle.copyOf(newNextOriginal1[0], (updated) => {
  //       updated.isApproved = true;
  //       updated.status = 'Approved';
  //     })
  //   ).then(async () => {

  //     //after we add another row for save report id for reporting managers approver
  //     const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
  //       "report_Id": reportId,
  //       "from_Employee_Id": loggedUserId,
  //       "to_Employee_Id": sixthPeriodAssignmentInitiateReport[0].particular_emp_reporting_manager,
  //       "status": 'Open',
  //       "isApproved": false,
  //       "remark": '',
  //       "date": moment().format("YYYY-MM-DD"),
  //     }));

  //     if (addNewRowForRMReasponse) {
  //       props.setRequestApprovalConfirmVisible(true);
  //       props.setCheckedSignature(false);
  //     }
  //   })





  // }


  return (
    <>
      {/* <Header /> */}
      <Header logo="sixperiod" />

      <div className="">
        <a to='' className="py-3"   onClick = {props.onClosePopup }><Image src={sidebar} alt="user" width="24" height="24" /></a>
        <div className='grid grid-cols-1 md:grid-cols-6 gap-4'>


          <div className='col-span-4'>
            <div className='mx-auto max-w-2xl border'>
              <div className="lg:flex lg:items-center py-5 lg:justify-between">
                <div className="min-w-0 flex-1">
                  <h6 className="flex items-center text-2xl font-semibold leading-7 text-gray-600 sm:truncate  sm:tracking-tight">
                    Sixth Period Teaching Assignment
                  </h6>
                  <p>Acknowledgement</p>
                  <h6 className='flex items-center mt-4'><DocumentTextIcon className="h-4 w-4 me-1" aria-hidden="true" /> Sixth Period Teaching Assignment.pdf</h6>
                  <div className='bg-[#eeeff0] py-4 px-6 mt-2 employee_handbookss'>
                    {/* <div className='bg-white text-center  p-5'>
                      <div className='flex justify-center'>
                        <div>
                          <h2 className='mb-3 py-2 px-5'>6th Period Teaching Assignment</h2>
                          <p>Glendale Unifed School District</p>
                          <img
                            className="w-100 mx-auto my-5"
                            src={Logo}
                            alt="Logo"
                          />
                        </div>
                      </div>
                      <Divider />
                      <p>2022-2023</p>
                    </div> */}

                    <HtmlToPdfSix
                      data={{
                        // 'employeeName': props.specificReportDetailsEdit ? props.specificReportDetailsEdit.employeeName : '',
                        // 'employeeId': "Empoyee.name",
                        // 'schoolName': "Private School",
                        // 'dateFrom': moment().format("YYYY-DD-MM"),
                        // 'dateTo': moment().format("YYYY-DD-MM"),
                        // 'subjectName': "Marathi",
                        // 'staffAllocation': "Pune",
                        // 'accountCharged': "50 rs",
                        // 'fteUtilized': "Fte"
						
						'approvalFinalData':props.specificReportDetailsEdit.approvalFinalData,
                        'employeeName': props.specificReportDetailsEdit.employeeName,
                        'employeeId': props.specificReportDetailsEdit.employee_id,
                        'schoolName': props.specificReportDetailsEdit.assighment_at,
                        'dateFrom': props.specificReportDetailsEdit.from_date,
                        'dateTo': props.specificReportDetailsEdit.to_date !== '' &&  props.specificReportDetailsEdit.to_date !== null ? moment(props.specificReportDetailsEdit.to_date).toDate() : '' ,
                        'subjectName': props.specificReportDetailsEdit.subject_area,
                        'staffAllocation': props.specificReportDetailsEdit.total_staffing_allocation,
                        'accountCharged': props.specificReportDetailsEdit.account_charged,
                        'fteUtilized': props.specificReportDetailsEdit.current_fte_utilized,
						'formName' : "Form C"
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-span-2 bg-white'>
            <div className='px-4 right_box border'>
              <div className="mb-1 mt-2">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Employee Name</label>
                <div className="mt-2">
                  <InputText value="" id="username" placeholder="" className="w-full placeholder:text-[#667085] bg-[#D0D5DD] h-10" aria-describedby=""   value={props.specificReportDetailsEdit ? props.specificReportDetailsEdit.employeeName : ''} /></div>
              </div>
              <div className="mb-1 mt-2">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Location</label>
                <div className="mt-2">
                  <InputText value={props.specificReportDetailsEdit.assighment_at} id="username" placeholder="United States" className="w-full placeholder:text-[#667085] h-10" aria-describedby="" /></div>
              </div>
              <div className="mb-1 mt-2">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Date</label>
                <div className="mt-2">
                  <InputText value="" id="username" placeholder="" className="w-full placeholder:text-[#667085] h-10" aria-describedby="" value={props.specificReportDetailsEdit ? moment(props.specificReportDetailsEdit.submittedOn).format("MM/DD/YYYY") : ''} /></div> 
              </div>
              {/*<div className="flex align-items-start box-checks p-3 mt-3 mb-80">*/}
			  {/* <Checkbox inputId="checks1" name="" value="checks" onChange={e => setChecked(e.checked)} checked={checked} />
					<label htmlFor="checks1" className="ml-2 text-[1vw]">
                  I have received, read, understand and agree to abide by this Acceptable Use Agreement,
                  BP/AR 4040 - Employee Use Of Technology, and other applicable laws and district policies
                  and regulations governing the use of district technology. I understand that there is no
                  expectation of privacy when using district technology or when my personal electronic
                  devices use district technology. I further understand that any violation may result in
                  revocation of users privileges, disciplinary action, and/or appropriate legal action.
                  I hereby release the district and its personnel from any and all claims and damages
                  arising from my use of district technoloy or from the failure of any technology
                  protection measures employed by the district.</label>
				*/}
              {/*</div>*/}

              <div className="mb-1 mt-2 pb-5">
                <div className="pl-5 pt-5 text-[#344054] font-medium text-[20px] flex">
                  <InputSwitch checked={props.addSignature} onChange={(e) => props.setAddSignature(e.value)}/>
                  <label style={{marginLeft: "2%"}}>Add Signature<span class="text-[red] pl-0.2">*</span></label>
                </div>

                {(props.addSignature && props.signatureFileAwsPath !== null) ?
                 <div className="py-3 px-5 rounded-[8px] mt-3">
                   <Card>
                     <img className={"w-[20%] h-[15%]"}
                          src={props.signatureFileAwsPath}                          
                     />
                   </Card>
                 </div> : null}
              </div>
            </div>



            <div className="grow flex justify-end gap-3 mb-3 mt-20 px-4">
              <Link to="" onClick = {props.onClosePopup } className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"> <i className="gusd-close mr-1" style={{ fontSize: '0.7rem' }}></i>Cancel</Link>
              <Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
             
                                                            onClick={handleRejectClick}
                                                        ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>
														
			  <button onClick={handleAcknowledgeClick}  disabled={buttonClicked || !props.addSignature || props.signatureFileAwsPath === null} className={`${(buttonClicked || !props.addSignature || props.signatureFileAwsPath === null) ? 'gray ' : 'blue ' } custmBtn radius8 text-center`}>Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SixperiodAgreement;